import { Anchor, Box, Group, Stack, Text, createStyles } from '@mantine/core'
import React from 'react'
import { useLottie } from 'lottie-react'
import { LottieAnimations } from 'src/assets'
import Fade from 'react-reveal/Fade'

export interface ContactDetailsProps {}

const useStyles = createStyles(theme => {
  return {
    textStyles: {
      color: theme.colorScheme === 'dark' ? theme.colors.gray[2] : theme.colors.gray[7],
      fontSize: theme.fontSizes.xl,
      '&:hover': {
        color: theme.colors.blue[4],
      },
      letterSpacing: 0.6,
    },
    anchorStyle: {
      '&:hover': {
        border: 'none',
        textDecoration: 'none',
      },
    },
    imageStyle: {
      div: {
        width: 40,
        height: 40,
      },
    },
  }
})

export const ContactDetails: React.FC<ContactDetailsProps> = () => {
  const { classes } = useStyles()

  const { email } = LottieAnimations.Contact

  const { View: EmailView } = useLottie({
    animationData: email,
    loop: true,
    autoplay: true,
  })

  return (
    <Stack justify="flex-start">
      <Fade left>
        {/* <Anchor className={classes.anchorStyle} href="tel:+916354701161" target="_blank" rel="noopener noreferrer">
          <Group>
            <Box className={classes.imageStyle}>{MobileView}</Box>
            <Text className={classes.textStyles}>+91 6354701161</Text>
          </Group>
        </Anchor> */}
        <Anchor
          className={classes.anchorStyle}
          href="mailto:tirthgpatel.27@gmail.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Group>
            <Box className={classes.imageStyle}>{EmailView}</Box>
            <Text className={classes.textStyles}>tirthgpatel.27@gmail.com</Text>
          </Group>
        </Anchor>
      </Fade>
    </Stack>
  )
}
